import { createContext, useEffect, useState } from 'react'

import { IBrandsResponseDTO } from '../../sdk/brand/brand.types'
import { IFinishedItemCategory } from '../../sdk/company-production/company-production.types'
import {
  IProductDetails,
  IProductsDashboard,
} from '../../sdk/products/products.types'
import { sdk } from '../../services/sdk'
import { CreateProductForm } from '../ProductDetails/components/CreateProductModal/create-product-modal.types'

interface ProductsDataContext {
  dashboardData: IProductsDashboard | undefined
  finishedItemCategories: IFinishedItemCategory[]
  brands: IBrandsResponseDTO[]
  actions: {
    getDashboardData: () => Promise<void>
    getProductByCode: (code: string) => Promise<IProductDetails>
    createProduct: (data: CreateProductForm) => Promise<void>
  }
}

interface TraceabilityProviderProps {
  children: React.ReactNode
}

export const ProductsContext = createContext({} as ProductsDataContext)

export function ProductsProvider(props: TraceabilityProviderProps) {
  const [dashboardData, setDashboardData] = useState<IProductsDashboard>()
  const [brands, setBrands] = useState<IBrandsResponseDTO[]>([])

  const [finishedItemCategories, setFinishedItemCategories] = useState<
    IFinishedItemCategory[]
  >([])

  const getFinishedItemCategories = async () => {
    try {
      const response = await sdk.finishedItemProfile.getCategories()

      setFinishedItemCategories(response)
    } catch (err) {}
  }

  const getDashboardData = async () => {
    try {
      const response = await sdk.products.getDashboard()
      setDashboardData(response)
    } catch (error) {}
  }

  const getProductByCode = async (code: string) => {
    return await sdk.products.getDetails(code)
  }

  const getBrands = async () => {
    const response = await sdk.brand.getBrands()
    setBrands(response)
  }

  useEffect(() => {
    getFinishedItemCategories()
    getBrands()
  }, [])

  const createProduct = async (body: CreateProductForm) => {
    await sdk.finishedItemProfile.saveFinishedItemProfile(body.code, {
      code: body.code,
      name: body.name,
      description: body.description,
      finishedItemCategoryId: body.finishedItemCategoryId,
      brandId: body.brandId,
    })
  }

  return (
    <ProductsContext.Provider
      value={{
        dashboardData,
        finishedItemCategories,
        brands,
        actions: {
          getDashboardData,
          getProductByCode,
          createProduct,
        },
      }}
    >
      {props.children}
    </ProductsContext.Provider>
  )
}
